import Content from './Content';

export default function MeasureDescription({ reportId }) {
  return <Content reportId={reportId} />;
}
